module.exports = __webpack_public_path__ + "img/c-1.9c953f63.png";